import React from "react";
import { post } from "../utils/request";
import api from "./api";
import Information from "./modules/information/index";
import template from "./template.js";
import "./index.less";

class processReview extends React.Component {
  constructor(props) {
    super(...props);
    this.state = {
      urlOps: {},
      detailData: {},
      data: {},
      status: {
        "-1": "初始化",
        0: "审批中", //'待审核',
        1: "已退回",
        11: "退回起草",
        2: "已审核",
        3: "已跳过",
        6: "已作废",
        7: "已撤销",
        8: "已关闭",
        9: "删除",
      },
      types: {
        CAR_SCRAP: {
          url: api.carScrap,
          preventXXSKey: "",
          title: (data) => {
            return `车辆资产处置_${data.carPlateNumber}`;
          },
        },
        PROGRAMME: {
          url: api.programme,
          preventXXSKey: "programmeContent",
          title: (data) => {
            if (data.levelTwo === "yxfa-8") {
              const programmeContent = JSON.parse(data.programmeContent);
              return `${data.levelTwoName}_${programmeContent.customerName}`;
            } else if (data.levelTwo === "escrwps") {
              return `方案呈批-二手车商入网评审-${data.programme}-${data.operator}-${data.applyTime}`
            } else if (data.levelTwo === 'esctwps') {
              return `方案呈批-二手车商退网评审-${data.programme}-费用支出(元)${ data.amount }-${data.operator}-${data.applyTime}`
            } else {
              return `方案呈批类_${data.programme}_费用：${data.amount}_${data.operator}_${data.applyTime}`;
            }
          },
        },
        CONTRACT: {
          url: api.contract,
          preventXXSKey:
            "survey,settlementMethod,obligations,liability,disputeResolution",
          title: (data) => {
            return `合同审批_${data.contractName}_费用：${data.contractAmount}_${data.operator}_${data.applyTime}`;
          },
        },
        PAY: {
          url: api.pay,
          preventXXSKey: "",
          title: (data) => {
            return `付款审批_${data.totalAmount}：${data.operator}_${data.applyTime}`;
          },
        },
        TRAVEL_PAY: {
          url: api.travelPay,
          preventXXSKey: "",
          title: (data) => {
            return `付款审批_费用：${data.operator}_${data.applyTime}`;
          },
        },
        ENTERTAIN_PAY: {
          url: api.entertainPay,
          preventXXSKey: "",
          title: (data) => {
            return `招待费付款_费用：${data.operator}_${data.applyTime}`;
          },
        },
        SEAL: {
          url: api.seal,
          preventXXSKey: "content",
          title: (data) => {
            return `用印申请类_${data.useSealTitle}_${
              data.sealType ? data.sealType.join() : ""
            }_${data.operator}_${data.applyTime}`;
          },
        },
        ENTERTAIN_APPLY: {
          url: api.entertainApply,
          preventXXSKey: "",
          title: (data) => {
            return `招待费事前申请类_${data.entertainType}_${data.entertainPerson}_${data.operator}_${data.applyTime}`;
          },
        },
        TRAVEL_APPLY: {
          url: api.travelApply,
          preventXXSKey: "",
          title: (data) => {
            if (data.traffics && data.traffics.length > 0) {
              return `出差申请类_${data.traffics[0].endAddress}_${data.operator}_${data.applyTime}`;
            } else {
              return `出差申请类_`;
            }
          },
        },
        SPECIAL: {
          url: api.special,
          preventXXSKey:
            "baseContent,litigationProgramme,legalServicesProgramme",
          title: (data) => {
            return `法律专项方案类_${data.specialScheme}_${data.amount}_${data.operator}_${data.applyTime}`;
          },
        },
        CAR_CONTROL_WHITE: {
          url: api.mattercs,
          preventXXSKey: "memo",
          title: (data) => {
            return `控车白名单申请_${data.matterTitle}_${data.operator}_${data.applyTime}`;
          },
        },
        TIME_CHANGE: {
          url: api.mattercs,
          preventXXSKey: "memo",
          title: (data) => {
            return `收车日期变更_${data.matterTitle}_${data.operator}_${data.applyTime}`;
          },
        },
        RECEIVED_BACK: {
          url: api.mattercs,
          preventXXSKey: "memo",
          title: (data) => {
            return `已收账单退回审批_${data.matterTitle}_${data.operator}_${data.applyTime}`;
          },
        },
        DATA_REVISION: {
          url: api.mattercs,
          preventXXSKey: "memo",
          title: (data) => {
            return `通用数据订正申请_${data.matterTitle}_${data.operator}_${data.applyTime}`;
          },
        },
      },
    };
  }
  componentWillMount() {
    var obj = "",
      obj1 = "",
      ops = {};
    if (window.location.hash.indexOf("?") > -1) {
      obj = window.location.hash.split("?")[1];
      obj1 = obj.split("&");
      for (var i = 0; i < obj1.length; i++) {
        ops[obj1[i].split("=")[0]] =
          obj1[i].split("=")[1] === "undefined" ? "" : obj1[i].split("=")[1];
      }
    }

    this.setState(
      {
        urlOps: ops,
      },
      () => {
        this.getData();
      }
    );
  }

  getSelectWorkCheckList() {
    const { detailData, urlOps } = this.state;

    post({
      url: `${api.selectWorkCheckList}?access_token=${urlOps.access_token}`,
      data: {
        workOrder: urlOps.workOrder,
        workNodeType: "DEF",
      },
    }).then(
      (res) => {
        // console.log('审批信息查询', res)
        // Toast.info(res.msg,1);
        if (res.result === "success" && res.data) {
          // console.log(res.data)
          let result = [];
          res.data.forEach((item) => {
            if (
              result.length > 0 &&
              item.groupNumber === result[result.length - 1].groupNumber
            ) {
              result[result.length - 1].child.push(item);
            } else {
              result.push({
                nodeName: item.nodeName,
                nodeAttr: item.nodeAttr,
                status: item.status,
                groupNumber: item.groupNumber,
                child: [item],
              });
            }
          });
          if (Array.isArray(detailData.informationTypes)) {
          } else {
            detailData.informationTypes = detailData.informationTypes();
          }
          detailData.informationTypes.push(template.examine(result));
          this.setState({
            detailData,
          });
        } else {
        }
      },
      (res) => {
        console.log("审批信息查询失败", res);
      }
    );
  }

  getData() {
    const { urlOps, types } = this.state;
    post({
      url: `${types[urlOps.bizType].url}?access_token=${urlOps.access_token}`,
      data: {
        workOrder: urlOps.workOrder,
      },
      preventXXSKey: types[urlOps.bizType].preventXXSKey,
    }).then(
      (res) => {
        // console.log('流程详情查询', res)
        // Toast.info(res.msg,1);
        if (res.result === "success" && res.data) {
          let data = res.data;

          // console.log(res.data)
          let workStatus = data.status;
          if (data.workBizType == "CAR_SCRAP") {
            workStatus = data.workStatus;
          }

          this.setState(
            {
              detailData: template[urlOps.bizType](data),
              data: { ...data, workStatus: workStatus },
            },
            () => {
              this.getSelectWorkCheckList();
            }
          );
        } else {
        }
      },
      (res) => {
        console.log("流程详情查询失败", res);
      }
    );
  }

  render() {
    const { status, data, urlOps, types } = this.state;
    return (
      <div className="processReviewBox">
        <div className="headerBox">
          <h2>{status[data.workStatus]}</h2>
          <p>{types[urlOps.bizType].title(data)}</p>
        </div>
        <Information data={this.state.detailData} />
      </div>
    );
  }
}

export default processReview;



// WEBPACK FOOTER //
// ./src/processReview/index.js